import { useMemo } from "react";
import { usePaginatedSmsSnippetsQuery } from "../../../../../../api/smsSnippets/usePaginatedSmsSnippetsQuery";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { useDebouncedState } from "../../../../../../utilities/hooks/useDebouncedState";
import { extractApiError } from "../../../../../../utilities/api";

export const useData = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets",
  });

  const [search, debouncedSearch, setSearch] = useDebouncedState("");

  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } =
    usePaginatedSmsSnippetsQuery(
      {
        pageSize: 15,
        search: debouncedSearch?.trim(),
      },
      {
        onError: (res) => {
          const message = extractApiError(res);
          uiNotification.error(t([`error.${message}`, "error.getAll"]));
        },
      },
    );

  const snippets = useMemo(() => {
    if (data && data.pages) {
      return data.pages
        .map((p) => p.snippets)
        .reduce((r, p) => [...r, ...p], []);
    }
    return [];
  }, [data]);

  return {
    data: snippets,
    statuses: {
      isLoading,
      isEmpty: !isLoading && snippets.length === 0,
      isDataVisible: !isLoading && snippets.length > 0,
      hasMoreData: hasNextPage,
      isNextDataFetching: isFetchingNextPage,
    },
    handlers: {
      fetchNextPage,
    },
    searchFilter: {
      value: search,
      onChange: setSearch,
    },
  };
};
